import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { apiClient } from '../../../services/apiClient';
import { useToast } from '../../../Toaster/ToastContext';
import { useDispatch } from 'react-redux';
import { setActiveOrder } from '../../redux/action';

const OrdersModal = ({ isOpen, onClose }) => {

  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [holdOrders, setHoldOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [expandedOrder, setExpandedOrder] = useState(null);

  const fetchHoldOrders = async () => {
    try {
      setIsLoading(true);
      const res = await apiClient.get(`/get-hold-sale`);
      if (res.status) {
        setHoldOrders(res.sales || []);
      } else {
        showToast(res.message || 'Failed to fetch sales', 'error', 'Sales');
      }
    } catch (err) {
      showToast('Something went wrong while loading sales', 'error', 'Sales');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && activeTab === 'all') {
      fetchHoldOrders();
    }
  }, [isOpen, activeTab]);

  const filteredOrders = holdOrders.filter(order => {
    if (activeTab === 'expiry') return order.status === 'Expire';
    if (activeTab === 'onhold') return order.status === 'Hold';
    if (activeTab === 'all') return order.status === 'Completed';
    if (activeTab === 'unpaid') return order.payment_status === 'Unpaid' || order.payment_status === 'Partial';
    if (activeTab === 'paid') return order.payment_status === 'Paid' || (order.status === 'Completed' && order.due === '0.00');
    return false;
  })
  .filter(order =>
    order.reference.toLowerCase().includes(searchQuery.toLowerCase()) ||
    order.customer.toLowerCase().includes(searchQuery.toLowerCase()) || order.note.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleOpenOrder = (order) => {
    // console.log(order);
    dispatch(setActiveOrder(order));
    onClose();
  };

  const handleViewProducts = (orderId) => {
    setExpandedOrder(expandedOrder === orderId ? null : orderId);
  };

  const handlePrint = (reference) => {
    window.print();
    showToast(`Printing order ${reference}`, 'info', 'Print');
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade pos-modal show" id="orders" tabIndex="-1" aria-labelledby="orders-label"
      style={{ display: 'block', zIndex: 1050 }}
      aria-modal="true" role="dialog"
    >
      <div className="modal-dialog modal-md modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="orders-label">Orders</h5>
            <button type="button" className="close" onClick={onClose} aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            {isLoading ? (
              <div className="text-center">Loading...</div>
            ) : (
              <div className="tabs-sets">
                <ul className="nav nav-tabs" id="myTabs" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                      onClick={() => setActiveTab('all')}
                      type="button"
                      aria-controls="all"
                      aria-selected={activeTab === 'all'}
                      role="tab"
                    >
                      Completed
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'onhold' ? 'active' : ''}`}
                      onClick={() => setActiveTab('onhold')}
                      type="button"
                      aria-controls="onhold"
                      aria-selected={activeTab === 'onhold'}
                      role="tab"
                    >
                      Onhold
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'expiry' ? 'active' : ''}`}
                      onClick={() => setActiveTab('expiry')}
                      type="button"
                      aria-controls="expiry"
                      aria-selected={activeTab === 'expiry'}
                      role="tab"
                    >
                      Expired
                    </button>
                  </li>
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'unpaid' ? 'active' : ''}`}
                      onClick={() => setActiveTab('unpaid')}
                      type="button"
                      aria-controls="unpaid"
                      aria-selected={activeTab === 'unpaid'}
                      role="tab"
                    >
                      Unpaid
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'paid' ? 'active' : ''}`}
                      onClick={() => setActiveTab('paid')}
                      type="button"
                      aria-controls="paid"
                      aria-selected={activeTab === 'paid'}
                      role="tab"
                    >
                      Paid
                    </button>
                  </li> */}
                </ul>
                <div className="tab-content">
                  {['expiry', 'onhold', 'all', 'unpaid', 'paid'].map(tab => (
                    <div
                      key={tab}
                      className={`tab-pane fade ${activeTab === tab ? 'show active' : ''}`}
                      id={tab}
                      role="tabpanel"
                      aria-labelledby={`${tab}-tab`}
                    >
                      <div className="input-icon-start pos-search position-relative mb-3">
                        <span className="input-icon-addon">
                          <i className="ti ti-search"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Reference or Customer"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          aria-label="Search orders"
                        />
                      </div>
                      <div className="order-body">
                        {filteredOrders.length === 0 ? (
                          <div className="text-center">No orders found</div>
                        ) : (
                          filteredOrders.map(order => (
                            <div
                              key={order.id}
                              className={`card bg-light ${filteredOrders.indexOf(order) === filteredOrders.length - 1 ? 'mb-0' : 'mb-3'}`}
                            >
                              <div className="card-body">
                                <span className="badge bg-dark fs-12 mb-2">{order.reference}</span>
                                <div className="row g-3">
                                  <div className="col-md-6">
                                    <p className="fs-15 mb-1">
                                      <span className="fs-14 fw-bold text-gray-9">Customer:</span>{' '}
                                      <span className="fs-14 text-gray-9">{order.customer}</span>
                                    </p>
                                    <p className="fs-15">
                                      <span className="fs-14 fw-bold text-gray-9">Total:</span>{' '}
                                      <span className="fs-14 text-gray-9">PKR {parseFloat(order.grand_total).toFixed(2)}</span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p className="fs-15 mb-1">
                                      <span className="fs-14 fw-bold text-gray-9">Date:</span>{' '}
                                      <span className="fs-14 text-gray-9">{new Date(order.date).toLocaleDateString()}</span>
                                    </p>
                                    <p className="fs-15">
                                      <span className="fs-14 fw-bold text-gray-9">Status:</span>{' '}
                                      <span className="fs-14 text-gray-9">{order.payment_status}</span>
                                    </p>
                                  </div>
                                  <div className="col-md-12">
                                    <p className="fs-15 fw-bold text-gray-9 my-2">Note</p>
                                    <p className="fs-14 text-gray-9 my-0">{order.note || 'No note available'}</p>
                                  </div>
                                  {order.status === 'Hold' && (
                                    <p className="text-muted mt-2">This order will expire after 8 hours.</p>
                                  )}
                                </div>
                                {activeTab === 'onhold' && (
                                <div className="d-flex align-items-center justify-content-center flex-wrap gap-2 mt-3">
                                  <button
                                    className="btn btn-md btn-orange"
                                    onClick={() => handleOpenOrder(order)}
                                    aria-label={`Open order ${order.reference}`}
                                  >
                                    Open Order
                                  </button>
                                  <button
                                    className="btn btn-md btn-teal"
                                    onClick={() => handleViewProducts(order.id)}
                                    aria-label={`Toggle products for order ${order.reference}`}
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#items-${order.id}`}
                                    aria-expanded={expandedOrder === order.id}
                                    aria-controls={`items-${order.id}`}
                                  >
                                    {expandedOrder === order.id ? 'Hide Products' : 'View Products'}
                                  </button>
                                  <button
                                    className="btn btn-md btn-indigo"
                                    onClick={() => handlePrint(order.reference)}
                                    aria-label={`Print order ${order.reference}`}
                                  >
                                    Print
                                  </button>
                                </div>
                                )}
                                <div
                                  className={`collapse ${expandedOrder === order.id ? 'show' : ''}`}
                                  id={`items-${order.id}`}
                                >
                                  <div className="card mt-3">
                                    <div className="card-body">
                                      <h6 className="fw-bold">Order Items</h6>
                                      <div className="table-responsive">
                                        <table className="table table-bordered">
                                          <thead>
                                            <tr>
                                              <th>Product Name</th>
                                              <th>Variant</th>
                                              <th>Quantity</th>
                                              <th>Price</th>
                                              <th>Subtotal</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {order.items && order.items.length > 0 ? (
                                              order.items.map((item, index) => (
                                                <tr key={index}>
                                                  <td>{item.product_name}</td>
                                                  <td>{item.variant_value || '-'}</td>
                                                  <td>{item.quantity}</td>
                                                  <td>PKR {item.price}</td>
                                                  <td>PKR {item.subtotal}</td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td colSpan="5">No items found</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

OrdersModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OrdersModal;